import { Component, computed, effect, ElementRef, inject, input, OnDestroy, OnInit, output, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DpIconComponent } from '@client-monorepo/common/icon';
import { EmitterService, EmittingDataEnum } from '@client-monorepo/common/utilities';
import { NgxBottomNavigationService } from '@digipay/ngx-bottom-navigation';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { BackHandlerService } from '@client-monorepo/back-handler';

@Component({
  selector: 'common-ui-components-page-layout',
  standalone: true,
  imports: [CommonModule, DpIconComponent],
  templateUrl: './page-layout.component.html',
  styleUrl: './page-layout.component.scss',
})
export class PageLayoutComponent implements OnInit, OnDestroy {
  private emitterService = inject(EmitterService);
  private elementRef = inject(ElementRef);

  title = input<string>();
  icon = input<string>();
  stickyHeader = input<boolean>(true);
  showBorder = input<boolean>(true);
  showBackIcon = input<boolean>(true);
  hasBackAction = input<boolean>(true);
  onBackAction = output<void>();
  onCustomAction = output<void>();
  pageBody = viewChild<ElementRef>('pageBody');
  emitted = false;
  bottomNavigationService = inject(NgxBottomNavigationService);
  hasScrolled = signal<boolean>(false);
  initialHeight = 0;
  headerClasses = input<string>('surface-elevated');
  bodyClasses = input<string>('surface-elevated');
  bodyStyle = computed(() => {
    const padding = this.hasScrolled() ? this.bottomNavigationService.reservedHeight() : 0;
    return {
      paddingBottom: `${padding}px`,
    };
  });
  routerSubscription!: Subscription;
  router = inject(Router);
  backHandler = inject(BackHandlerService);
  timeOUt!: any;

  constructor() {
    effect(
      () => {
        if (this.pageBody()) {
          if (this.timeOUt) {
            clearTimeout(this.timeOUt);
          }
          this.timeOUt = setTimeout(() => {
            this.checkScroll();
          });
        }
      },
      { allowSignalWrites: true },
    );
  }

  ngOnInit() {
    this.initComponent();
  }

  initComponent(): void {
    const element = this.elementRef?.nativeElement?.ownerDocument.body;
    this.initialHeight = element.clientHeight;
  }

  checkScroll(): void {
    const element = this.pageBody()?.nativeElement;
    this.hasScrolled.set(element.clientHeight > this.initialHeight - this.bottomNavigationService.reservedHeight());
  }

  handleActionClick(): void {
    if (this.hasBackAction()) {
      this.backHandler.goBack();
    }
    this.onBackAction.emit();
  }

  handleScroll(event: any): void {
    if (this.pageBody()?.nativeElement === event.currentTarget) {
      const pos = (this.pageBody()?.nativeElement.scrollTop || document.body.scrollTop) + this.pageBody()?.nativeElement.offsetHeight;
      const max = this.pageBody()?.nativeElement.scrollHeight;
      if (pos >= max - 50) {
        if (!this.emitted) {
          this.emitterService.emitEvent(EmittingDataEnum.PAGE_LAYOUT_SCROLLED_TO_END);
          this.emitted = true;
          this.checkScroll();
        }
      } else {
        this.emitted = false;
      }
    }
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }
}
